// extracted by mini-css-extract-plugin
export var icon = "_qo-0";